import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { AddEditTimeScheduleModalComponent } from "../add-edit-time-schedule-modal/add-edit-time-schedule-modal.component";
import { takeUntil } from "rxjs/operators";
import { ContentActionComponent } from "src/app/shared/content-action/content-action.component";
import { Confirmation } from "src/app/enums/confirmation.enum";

@Component({
  selector: "fury-time-scheduler-tab",
  templateUrl: "./time-scheduler-tab.component.html",
  styleUrls: ["./time-scheduler-tab.component.scss"],
})
export class TimeSchedulerTabComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  displayedColumns = [
    "0:00",
    "0:30",
    "1:00",
    "1:30",
    "2:00",
    "2:30",
    "3:00",
    "3:30",
    "4:00",
    "4:30",
    "5:00",
    "5:30",
    "6:00",
    "6:30",
    "7:00",
    "7:30",
    "8:00",
    "8:30",
    "9:00",
    "9:30",
    "10:00",
    "10:30",
    "11:00",
    "11:30",
    "12:00",
    "12:30",
    "13:00",
    "13:30",
    "14:00",
    "14:30",
    "15:00",
    "15:30",
    "16:00",
    "16:30",
    "17:00",
    "17:30",
    "18:00",
    "18:30",
    "19:00",
    "19:30",
    "20:00",
    "20:30",
    "21:00",
    "21:30",
    "22:00",
    "22:30",
    "23:00",
    "23:30",
    "23:59",
  ];

  @Input() scheduleData = {
    Sunday: [],
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
  };
  @Output() timeSchedulePayload = new EventEmitter<any>();
  scheduleGridValues = null;
  selectedCellValue = null;
  clearCellSelection = false;
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.displayValueToTheGrid();
  }
  onTabChange(event: any) {
    this.clearSelection();
  }

  checkAvailableDay(dayName: string) {
    let availableDay = this.scheduleData[dayName].find((item => item.status === "Available"));
    return availableDay ? true : false;
  }

  checkAvailability(schedule, timeSlots) {
    const result = {};
    const validStatuses = new Set(["Available"]);

    const timeSlotIndex = timeSlots.reduce((acc, slot, index) => {
      acc[slot] = index;
      return acc;
    }, {});
    if (!Object.keys(schedule).length) return {};
    for (const day in schedule) {
      const daySlots = schedule[day];
      const availabilityMap = {};

      timeSlots.forEach((slot) => {
        availabilityMap[slot] = false;
        availabilityMap[`${slot}startTime`] = null;
        availabilityMap[`${slot}endTime`] = null;
      });

      daySlots.forEach((entry) => {
        const { startTime, endTime, status } = entry;
        if (validStatuses.has(status)) {
          const startIndex = timeSlotIndex[startTime];
          const endIndex = timeSlotIndex[endTime];

          if (startIndex !== undefined && endIndex !== undefined) {
            for (let i = startIndex; i <= endIndex; i++) {
              const currentSlot = timeSlots[i];
              availabilityMap[currentSlot] = true;
              availabilityMap[`${currentSlot}startTime`] = startTime;
              availabilityMap[`${currentSlot}endTime`] = endTime;
            }
          }
        }
      });
      result[day] = availabilityMap;
    }

    return result;
  }
  checkSchedule(event: any) {
    this.selectedCellValue = event;
    this.clearCellSelection = false;
  }
  clearSelection() {
    this.clearCellSelection = true;
    this.selectedCellValue = null;
  }
  handleAddEditTimeScheduleModal(isAddType: boolean, dayName: string) {
    this.dialog
      .open(AddEditTimeScheduleModalComponent, {
        data: { isAddType, dayName, selectedCellValue: this.selectedCellValue },
        panelClass: "payment-info"
      })
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.assignValue(res);
          }
        },
      });
  }
  assignValue(res: any) {
    const {
      startTime,
      endTime,
      status,
      dayName,
      isAddType,
      previousScheduleData,
    } = res;
    if (isAddType) {
      this.scheduleData[dayName].push({ startTime, endTime, status });
      this.displayValueToTheGrid();
    } else {
      this.scheduleData[dayName] = this.scheduleData[dayName].reduce(
        (updatedSlots, slot) => {
          if (
            slot.startTime === previousScheduleData.startTime &&
            slot.endTime === previousScheduleData.endTime
          ) {
            updatedSlots.push({ ...slot, status, startTime, endTime });
          } else {
            updatedSlots.push(slot);
          }
          return updatedSlots;
        },
        []
      );
      this.displayValueToTheGrid();
    }
  }
  deleteTimeSlot(dayName: string) {
    const selectedCellValue = this.selectedCellValue;
    const dialogRef = this.dialog.open(ContentActionComponent, {
      width: "500px",
      data: {
        type: "deleteTimeSchedule",
        startTime: this.selectedCellValue?.startTime,
        endTime: this.selectedCellValue?.endTime,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: Confirmation) => {
        if (res === Confirmation.Yes) {
          this.scheduleData[dayName] = this.scheduleData[dayName].filter(
            (slot) => {
              return !(
                slot?.startTime === selectedCellValue?.startTime &&
                slot?.endTime === selectedCellValue?.endTime
              );
            }
          );
          this.displayValueToTheGrid();
        }
      });
  }
  resetTimeSchedule(dayName: string) {
    const selectedCellValue = this.selectedCellValue;
    const dialogRef = this.dialog.open(ContentActionComponent, {
      width: "500px",
      data: {
        type: "resetSchedule",
        dayName,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: Confirmation) => {
        if (res === Confirmation.Yes) {
          this.scheduleData[dayName] = [];
          this.displayValueToTheGrid();
        }
      });
  }
  displayValueToTheGrid() {
    this.scheduleGridValues = this.checkAvailability(
      this.scheduleData,
      this.displayedColumns
    );
    this.timeSchedulePayload.emit(this.scheduleData);
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
